import { useSetTransfered } from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/TransferProvider";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const TransferredSuccessMsg = () => {
  const setTransferred = useSetTransfered();
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTransferred(false);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return <div>{t("Satt videre")}</div>;
};

export default TransferredSuccessMsg;
